import { useTranslation } from 'react-i18next';

function renderParagraphs(text: string, className: string) {
  return text.split(/\n{2,}/).map((paragraph, index) => (
    <p key={index} className={className}>
      {paragraph}
    </p>
  ));
}

export default function IncomeSection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          {renderParagraphs(
            t('butlerJob.income.label'),
            'text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label',
          )}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('butlerJob.income.title')}
          </h2>
          {renderParagraphs(
            t('butlerJob.income.subtitleEn'),
            'section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4',
          )}
          <div className="gold-line mx-auto mb-6"></div>
          {renderParagraphs(
            t('butlerJob.income.lead'),
            'text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto',
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-8">
          <div className="card-glow bg-background-50 border border-background-200/60 p-6 md:p-7 flex flex-col md:row-span-2">
            <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.06em] mb-4">
              {t('butlerJob.income.uk.title')}
            </h3>
            <div className="text-[16px] text-foreground-500 tracking-[0.04em] leading-[1.85] whitespace-pre-line">
              {t('butlerJob.income.uk.body')}
            </div>
          </div>
          <div className="card-glow bg-background-50 border border-background-200/60 p-6 md:p-7 flex flex-col">
            <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.06em] mb-3">
              {t('butlerJob.income.us.title')}
            </h3>
            {renderParagraphs(
              t('butlerJob.income.us.body'),
              'text-[16px] text-foreground-500 tracking-[0.04em] leading-[1.85]',
            )}
          </div>
          <div className="card-glow bg-background-50 border border-background-200/60 p-6 md:p-7 flex flex-col">
            <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.06em] mb-3">
              {t('butlerJob.income.europe.title')}
            </h3>
            {renderParagraphs(
              t('butlerJob.income.europe.body'),
              'text-[16px] text-foreground-500 tracking-[0.04em] leading-[1.85]',
            )}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-8">
          <div className="bg-background-50 border border-background-200/60 p-6 md:p-8">
            <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.06em] mb-3">
              {t('butlerJob.income.factors.title')}
            </h3>
            {renderParagraphs(
              t('butlerJob.income.factors.body'),
              'text-[16px] text-foreground-500 tracking-[0.04em] leading-[1.85]',
            )}
          </div>
          <div className="bg-background-50 border border-background-200/60 p-6 md:p-8">
            <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.06em] mb-3">
              {t('butlerJob.income.japan.title')}
            </h3>
            {renderParagraphs(
              t('butlerJob.income.japan.body'),
              'text-[16px] text-foreground-500 tracking-[0.04em] leading-[1.85]',
            )}
          </div>
        </div>

        {renderParagraphs(
          t('butlerJob.income.note'),
          'text-[13px] md:text-[14px] text-foreground-500 tracking-[0.04em] leading-relaxed max-w-[820px]',
        )}
      </div>
    </section>
  );
}
